"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.PureSubmitContainer = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _ccxIngest = require("@ccx-public/ccx-ingest");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Send = _interopRequireDefault(require("@react/react-spectrum/Icon/Send"));

var _Login = _interopRequireDefault(require("../components/Login/Login"));

var _CommentInput = _interopRequireDefault(require("../components/CommentInput/CommentInput"));

var _CallbackContext = _interopRequireDefault(require("../context/CallbackContext"));

var _AnnotationToolbar = _interopRequireDefault(require("./AnnotationToolbar"));

var _Divider = _interopRequireDefault(require("../components/Divider/Divider"));

var _CommentsSubmitView = _interopRequireDefault(require("../style/CommentsSubmitView.scss"));

var _constants = require("../constants");

var _annotations = require("../selectors/annotations");

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _AppContext = require("../context/AppContext");

var ContextActions = _interopRequireWildcard(require("../actions/context"));

var _reducers = require("../reducers");

var _utils = require("../lib/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * SubmitContainer component
 * @reactProps {object} [assetData = {}] - data related to the current asset
 * @reactProps {string} assetData.id - id of the current asset
 * @reactProps {string} assetData.nodeId - id of the node within the asset
 * @reactProps {string} assetData.ownerId - id of owner of the current asset
 * @reactProps {string} assetData.region - region of the current asset
 * @reactProps {function} commentsPost - action for posting a comment
 * @reactProps {string} currentView - current view mode of comments (resolved vs unresolved)
 * @reactProps {object} [ccxIngest = {}] - controller instance of ccx Ingest
 * @reactProps {string} imsData.id - id of the current user
 * @reactProps {string} imsData.token - token of the current user
 * @reactProps {function} commentsAddDirtyComment - action for adding a comment to the dirty state
 */
var SubmitContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(SubmitContainer, _React$Component);

  var _super = _createSuper(SubmitContainer);

  /**
   * Constructor for the SubmitContainer
   * @param {Object} props - the props sent to the component
   * @return {undefined}
   */
  function SubmitContainer(props) {
    var _this;

    _classCallCheck(this, SubmitContainer);

    _this = _super.call(this, props);
    _this.state = {
      commentText: '',
      overTextLimit: false,
      posting: false,
      showLogin: false
    };
    _this.handleIngestEvents = _this.handleIngestEvents.bind(_assertThisInitialized(_this));
    _this.handleOnFocus = _this.handleOnFocus.bind(_assertThisInitialized(_this));
    _this.handleOnKeyUp = _this.handleOnKeyUp.bind(_assertThisInitialized(_this));
    _this.updateSessionStorageAnnotationLocation = _this.updateSessionStorageAnnotationLocation.bind(_assertThisInitialized(_this));
    _this.handleTextareaRef = _this.handleTextareaRef.bind(_assertThisInitialized(_this));
    _this.handleCommentSubmit = _this.handleCommentSubmit.bind(_assertThisInitialized(_this));
    _this.handleTextPresent = _this.handleTextPresent.bind(_assertThisInitialized(_this));
    _this.handleLoginCancel = _this.handleLoginCancel.bind(_assertThisInitialized(_this));
    _this.handleSubmitCancel = _this.handleSubmitCancel.bind(_assertThisInitialized(_this));
    _this.handleReset = _this.handleReset.bind(_assertThisInitialized(_this));
    _this.handleAnnotationClick = _this.handleAnnotationClick.bind(_assertThisInitialized(_this));
    _this.handleComponentClick = _this.handleComponentClick.bind(_assertThisInitialized(_this));
    _this.handleMentionClick = _this.handleMentionClick.bind(_assertThisInitialized(_this));
    _this.handleGuestLogin = _this.handleGuestLogin.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Called when component props have updated
   * @param {Object} prevProps - previous props of the component
   * @param {Object} prevState - previous state of the component
   * @returns {undefined}
   */


  _createClass(SubmitContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          annotatingItmId = _this$props.annotatingItmId,
          assetData = _this$props.assetData,
          hasAnnotationLocation = _this$props.hasAnnotationLocation,
          commentsCloseBtnClicked = _this$props.commentsCloseBtnClicked,
          guestSessionState = _this$props.guestSessionState;
      var textareaInstance = this._textareaEl;

      if (!prevProps.hasAnnotationLocation && hasAnnotationLocation && annotatingItmId === 'root') {
        if (!prevProps.compactLayout) {
          textareaInstance.setFocus();
        }
      }

      if (prevProps.commentsCloseBtnClicked !== commentsCloseBtnClicked && prevProps.focusedInputInfo[prevProps.assetData.nodeId] && prevProps.focusedInputInfo[prevProps.assetData.nodeId].itemType === 'root') {
        this.handleReset();
      } // if changing artboards


      if (prevProps.assetData.nodeId !== assetData.nodeId && !prevProps.annotationsMultiPageEnabled) {
        // save the current annotation location on the old artboard
        prevProps.commentsAddDirtyComment(prevProps.assetData.nodeId, prevState.commentText || null, {
          coordinates: prevProps.annotationLocationCoordinates,
          nodeId: prevProps.annotationLocationNodeId
        }); // get the annotation location of the new artboard

        var location = (0, _lodash.default)(prevProps.dirtyComments, "".concat(assetData.nodeId, ".location"));

        if (location) {
          prevProps.saveAnnotationLocation(location.coordinates, location.nodeId);
        } // Reset component state


        this.setState({
          commentText: '',
          showLogin: false
        });
      }

      if (prevProps.guestSessionState !== guestSessionState && (guestSessionState === 'expires-soon' || guestSessionState === 'expired')) {
        this.setState({
          showLogin: true
        });
      }
    }
    /**
     * Update the annotation location in session storage
     * @returns {undefined}
     */

  }, {
    key: "updateSessionStorageAnnotationLocation",
    value: function updateSessionStorageAnnotationLocation() {
      var _this$props2 = this.props,
          annotationLocationCoordinates = _this$props2.annotationLocationCoordinates,
          annotationLocationNodeId = _this$props2.annotationLocationNodeId;
      var comment = (0, _utils.loadFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN) || {};
      comment.annotationLocation = {
        coordinates: annotationLocationCoordinates,
        nodeId: annotationLocationNodeId
      };
      (0, _utils.saveToSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN, comment);
    }
    /**
     * Sets the local state of the textarea content so we know when to
     * disable the submit button and stop enter key submit
     * @param {String} commentText - the comment text
     * @param {Boolean} overTextLimit - if length >= maxCharacters
     * @return {undefined}
     */

  }, {
    key: "handleTextPresent",
    value: function handleTextPresent(commentText, overTextLimit) {
      var textPresent = commentText.length > 0;
      this.setState({
        commentText: commentText,
        overTextLimit: overTextLimit,
        textPresent: textPresent
      });
    }
    /**
     * Handles the final calling ccxIngest.fireEvent after spreading in
     * the particular event config with the default properties
     * @param {Object} config - unique fields to include in event object
     * @param {boolean} shouldFlush - indication if the event should fire immediately
     * @return {undefined}
     */

  }, {
    key: "handleIngestEvents",
    value: function handleIngestEvents(config, shouldFlush) {
      var _this$props3 = this.props,
          ccxIngest = _this$props3.ccxIngest,
          newAnnotationType = _this$props3.newAnnotationType;
      return ccxIngest.fireEvent({
        event: _objectSpread({
          subcategory: newAnnotationType ? "".concat(newAnnotationType, "-comment") : 'post-comment'
        }, config)
      }, shouldFlush);
    }
    /**
     * Handle focus event and calls ingest to registor event
     * @return {undefined}
     */

  }, {
    key: "handleOnFocus",
    value: function handleOnFocus() {
      var _this$props4 = this.props,
          saveFocusedInputInfo = _this$props4.saveFocusedInputInfo,
          compactLayout = _this$props4.compactLayout,
          assetData = _this$props4.assetData,
          focusedInputInfo = _this$props4.focusedInputInfo; // INGEST [POST COMMENT]: user clicks the text box to initiate a new comment

      var config = {
        subtype: 'text-box',
        type: 'click'
      };
      this.handleIngestEvents(config);

      if (compactLayout) {
        var objFocusedInputInfo = focusedInputInfo || {};
        objFocusedInputInfo[assetData.nodeId] = {
          itemType: 'root'
        };
        saveFocusedInputInfo(objFocusedInputInfo);
      }
    }
    /**
     * Handle enter key submit comment by calling submitComment if passes conditions
     * @param {Event} evt - javascript event object
     * @return {undefined}
     */

  }, {
    key: "handleOnKeyUp",
    value: function handleOnKeyUp(evt) {
      var _this$props5 = this.props,
          annotationLocationCoordinates = _this$props5.annotationLocationCoordinates,
          isOffline = _this$props5.isOffline;
      var _this$state = this.state,
          commentText = _this$state.commentText,
          posting = _this$state.posting,
          overTextLimit = _this$state.overTextLimit,
          textPresent = _this$state.textPresent;
      var pendingStrikethroughAnnotation = annotationLocationCoordinates && annotationLocationCoordinates.subtype === 'strikethrough';
      var disableSavingChanges = isOffline || overTextLimit || posting || (!textPresent || !commentText.trim().length) && !pendingStrikethroughAnnotation;

      if ((0, _utils.isKeyboardSubmit)(evt) && !disableSavingChanges) {
        this.handleCommentSubmit(null, commentText);
      }
    }
    /**
     * Handle user clicking on mention button
     * @return {undefined}
     */

  }, {
    key: "handleMentionClick",
    value: function handleMentionClick() {
      var ccxIngest = this.props.ccxIngest;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'post-comment',
          type: 'click',
          subtype: 'mention'
        }
      });
    }
    /**
     * Handle user clicking on mention button
     * @return {undefined}
     */

  }, {
    key: "handleGuestLogin",
    value: function handleGuestLogin() {
      var _this$_textareaEl;

      this.setState({
        showLogin: false
      });
      (_this$_textareaEl = this._textareaEl) === null || _this$_textareaEl === void 0 ? void 0 : _this$_textareaEl.clearTextareaInput();
    }
    /**
     * Handle submit button click and calls submitComment if passes conditions
     * @param {Event} evt - javascript event object
     * @param {String} commentText - the comment text
     * @return {undefined}
     */
    // eslint-disable-next-line

  }, {
    key: "handleCommentSubmit",
    value: function handleCommentSubmit(evt, commentText) {
      var _this$props6 = this.props,
          annotationLocationCoordinates = _this$props6.annotationLocationCoordinates,
          annotationLocationNodeId = _this$props6.annotationLocationNodeId,
          assetData = _this$props6.assetData,
          annotatingItmId = _this$props6.annotatingItmId,
          imsData = _this$props6.imsData;
      var textareaInstance = this._textareaEl;
      var commentFromTextInput = textareaInstance && textareaInstance.getTextareaInputValue(true);

      if (!imsData || !imsData.token) {
        if (commentFromTextInput) {
          (0, _utils.saveToSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN, {
            annotationLocation: {
              coordinates: annotationLocationCoordinates,
              nodeId: annotationLocationNodeId
            },
            annotatingItmId: annotatingItmId,
            id: assetData.id,
            nodeId: assetData.nodeId,
            bodyValue: commentFromTextInput
          });
        }

        this.setState({
          showLogin: true
        });
        return;
      } // if commentText is not passed as a param, use the input from the text input


      var comment = commentText || commentFromTextInput;
      this.submitComment(comment);
    }
    /**
     * private function to clean current node focused input box information from redux
     * @return {undefined}
     */

  }, {
    key: "cleanCurrentNodeFocusedInputInfo",
    value: function cleanCurrentNodeFocusedInputInfo() {
      var _this$props7 = this.props,
          assetData = _this$props7.assetData,
          compactLayout = _this$props7.compactLayout,
          saveFocusedInputInfo = _this$props7.saveFocusedInputInfo,
          focusedInputInfo = _this$props7.focusedInputInfo;

      if (compactLayout) {
        var tempFocusedInputInfo = focusedInputInfo || {};
        delete tempFocusedInputInfo[assetData.nodeId];

        if (Object.keys(tempFocusedInputInfo).length > 0) {
          saveFocusedInputInfo(tempFocusedInputInfo);
        } else {
          saveFocusedInputInfo();
        }
      }
    }
    /**
     * Calls ingest and post the comment
     * @param {String} commentText - the comment text
     * @return {undefined}
     */

  }, {
    key: "submitComment",
    value: function submitComment(commentText) {
      var _this2 = this;

      var _this$props8 = this.props,
          assetData = _this$props8.assetData,
          cacheComments = _this$props8.cacheComments,
          commentsPost = _this$props8.commentsPost,
          annotatingItmId = _this$props8.annotatingItmId,
          mentionsEnabled = _this$props8.mentionsEnabled,
          compactLayout = _this$props8.compactLayout,
          commentsListMinimized = _this$props8.commentsListMinimized,
          contextSetCommentsListMinimized = _this$props8.contextSetCommentsListMinimized,
          imageCapture = _this$props8.imageCapture,
          imageContextData = _this$props8.imageContextData,
          imsData = _this$props8.imsData,
          resetGuestUserSession = _this$props8.resetGuestUserSession;
      var onLogin = this.context.onLogin; // restore comments list height if minimized

      if (compactLayout && commentsListMinimized) {
        contextSetCommentsListMinimized(false);
      }

      var config = {
        subtype: 'submit',
        type: 'keystroke'
      };
      var textareaInstance = this._textareaEl;
      var mentionedUsers = [];
      this.handleIngestEvents(config);
      var cmtTxt = commentText.trim();

      if (mentionsEnabled) {
        mentionedUsers = textareaInstance && textareaInstance.getAcceptedMentions();
        cmtTxt = (0, _utils.replaceNameWithID)(commentText, mentionedUsers);
      }

      this.setState({
        textPresent: false,
        posting: true,
        showLogin: false
      }); // keep track of the posted text in case we need to show it again in the case of an error

      this.postingText = cmtTxt;
      textareaInstance && textareaInstance.clearTextareaInput();
      this.cleanCurrentNodeFocusedInputInfo();
      commentsPost(assetData.id, assetData.nodeId, cmtTxt, cacheComments, annotatingItmId === 'root', mentionedUsers, imageCapture, imageContextData).then(function () {
        _this2.setState({
          posting: false
        });

        (0, _utils.deleteFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN);

        if (compactLayout) {
          _this2.handleReset();
        }
      }).catch(function (error) {
        _this2.setState({
          posting: false
        });

        (0, _utils.deleteFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN);
        textareaInstance && textareaInstance.setTextareaInputValue(_this2.postingText);

        _this2.handleIngestEvents({
          subtype: 'error',
          type: 'render',
          error_code: error.status,
          error_type: error.message,
          error_desc: 'comment-failed-to-post'
        });

        if (imsData.token.includes('AnonBearer') && error.status === 401) {
          resetGuestUserSession();
          onLogin(false);
        }
      });
    }
    /**
     * Handle click on an annotation button
     * @param {Event} evt - javascript event object
     * @param {Stright} annotationType - string identifier for annotation type
     * @return {undefined}
     */

  }, {
    key: "handleAnnotationClick",
    value: function handleAnnotationClick(evt, annotationType) {
      var _this$props9 = this.props,
          annotationLocationNodeId = _this$props9.annotationLocationNodeId,
          annotationsMultiPageEnabled = _this$props9.annotationsMultiPageEnabled,
          assetData = _this$props9.assetData,
          ccxIngest = _this$props9.ccxIngest,
          hasAnnotationLocation = _this$props9.hasAnnotationLocation,
          isPlacingAnnotation = _this$props9.isPlacingAnnotation,
          annotatingItmId = _this$props9.annotatingItmId,
          saveAnnotationLocation = _this$props9.saveAnnotationLocation,
          setAnnotationMode = _this$props9.setAnnotationMode,
          compactLayout = _this$props9.compactLayout,
          commentsListMinimized = _this$props9.commentsListMinimized,
          contextSetCommentsListMinimized = _this$props9.contextSetCommentsListMinimized,
          touchControls = _this$props9.touchControls;
      evt && evt.preventDefault(); // minimize the overlay only when the user is trying to place an annotation and not removing it

      if (compactLayout && !commentsListMinimized && !hasAnnotationLocation) {
        contextSetCommentsListMinimized(true);
      } // dismiss virtual keyboard when placing a new annotation


      if ((compactLayout || touchControls) && document.activeElement && document.activeElement.classList.contains('textarea')) {
        document.activeElement.blur();
      } // Construct ingest call


      ccxIngest.fireEvent({
        event: {
          subcategory: "".concat(annotationType, "-comment"),
          type: 'click',
          subtype: isPlacingAnnotation ? "".concat(annotationType, "-leave") : "".concat(annotationType, "-enter")
        }
      });

      if (hasAnnotationLocation && (!annotationsMultiPageEnabled || assetData.nodeId === annotationLocationNodeId)) {
        setAnnotationMode(false);
        saveAnnotationLocation();
      } else {
        var annotationMode = !(isPlacingAnnotation && annotatingItmId === 'root');

        if (annotationsMultiPageEnabled && hasAnnotationLocation) {
          annotationMode = annotationLocationNodeId !== assetData.nodeId;
        }

        var showAnnotationMask = annotationMode;

        if (hasAnnotationLocation && annotationsMultiPageEnabled && assetData.nodeId !== annotationLocationNodeId) {
          saveAnnotationLocation();
        }

        setAnnotationMode(annotationMode, 'root', showAnnotationMask, annotationType);
      }
    }
    /**
     * Handle resetting the component
     * @return {undefined}
     */

  }, {
    key: "handleReset",
    value: function handleReset() {
      var _this$props10 = this.props,
          assetData = _this$props10.assetData,
          commentsAddDirtyComment = _this$props10.commentsAddDirtyComment,
          saveAnnotationLocation = _this$props10.saveAnnotationLocation,
          setAnnotationMode = _this$props10.setAnnotationMode;
      var textareaInstance = this._textareaEl;
      textareaInstance && textareaInstance.clearTextareaInput();
      setAnnotationMode(false);
      saveAnnotationLocation();
      commentsAddDirtyComment(assetData.nodeId, '');
      this.cleanCurrentNodeFocusedInputInfo();
      this.setState({
        commentText: ''
      });
    }
    /**
     * Handle cancel button click
     * @return {undefined}
     */

  }, {
    key: "handleSubmitCancel",
    value: function handleSubmitCancel() {
      this.handleReset();
    }
    /**
     * Handle login cancelling
     * @return {undefined}
     */

  }, {
    key: "handleLoginCancel",
    value: function handleLoginCancel() {
      this.setState(function () {
        return {
          showLogin: false
        };
      });
      (0, _utils.deleteFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN);
    }
    /**
     * Create reference to the textarea input
     * @param {ReactElement} ref - react element to create a reference to
     * @return {undefined}
     */

  }, {
    key: "handleTextareaRef",
    value: function handleTextareaRef(ref) {
      this._textareaEl = ref;
    }
    /**
     * Click handler for the component
     * @return {undefined}
     */

  }, {
    key: "handleComponentClick",
    value: function handleComponentClick() {
      var _this$props11 = this.props,
          setUnmappedView = _this$props11.setUnmappedView,
          viewingUnmapped = _this$props11.viewingUnmapped;

      if (viewingUnmapped) {
        setUnmappedView(false);
      }
    }
    /**
     * Returns login buttons or comment box with button
     * @param {Object} imsData - user imsData with token key, used to determine what view to show
     * @return {ReactElement} - current view user is allowable
     */

  }, {
    key: "_getContentBody",
    value: function _getContentBody(imsData) {
      var _this$props12 = this.props,
          annotationColor = _this$props12.annotationColor,
          annotationLocationCoordinates = _this$props12.annotationLocationCoordinates,
          annotationTypes = _this$props12.annotationTypes,
          annotationsEnabled = _this$props12.annotationsEnabled,
          annotationsCreationEnabled = _this$props12.annotationsCreationEnabled,
          annotationsMultiPageEnabled = _this$props12.annotationsMultiPageEnabled,
          assetData = _this$props12.assetData,
          compactLayout = _this$props12.compactLayout,
          dirtyComments = _this$props12.dirtyComments,
          focusedInputInfo = _this$props12.focusedInputInfo,
          hasAnnotationLocation = _this$props12.hasAnnotationLocation,
          isPlacingAnnotation = _this$props12.isPlacingAnnotation,
          isReadyToAnnotate = _this$props12.isReadyToAnnotate,
          mentionsEnabled = _this$props12.mentionsEnabled,
          onHeightChange = _this$props12.onHeightChange,
          newAnnotationType = _this$props12.newAnnotationType,
          annotatingItmId = _this$props12.annotatingItmId,
          saveAnnotationColor = _this$props12.saveAnnotationColor,
          touchControls = _this$props12.touchControls,
          isOffline = _this$props12.isOffline,
          richTextEntry = _this$props12.richTextEntry;
      var _this$state2 = this.state,
          overTextLimit = _this$state2.overTextLimit,
          posting = _this$state2.posting,
          textPresent = _this$state2.textPresent,
          commentText = _this$state2.commentText;
      var isAnnotating = !!(isPlacingAnnotation || hasAnnotationLocation) && annotatingItmId === 'root';
      var signedOut = !imsData || !imsData.token;
      var pendingStrikethroughAnnotation = annotationLocationCoordinates && annotationLocationCoordinates.subtype === 'strikethrough';
      var disableSavingChanges = isOffline || overTextLimit || posting || (!textPresent || !commentText.trim().length) && !pendingStrikethroughAnnotation;

      var submitButtonWithoutTooltip = /*#__PURE__*/_react.default.createElement(_Button.default, {
        disabled: disableSavingChanges,
        id: "ccx-comments-submit-btn",
        variant: "cta",
        onClick: this.handleCommentSubmit
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "comments.submit.submit"
      }));

      var submitButtonWithTooltip = /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
        placement: "left",
        trigger: "hover"
      }, submitButtonWithoutTooltip, /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "comments.offline.submit.tooltip"
      })));

      var cancelButtonContainer = /*#__PURE__*/_react.default.createElement(_Button.default, {
        disabled: (!textPresent || posting) && !isAnnotating,
        id: "ccx-comments-cancel-btn",
        quiet: true,
        onMouseDown: this.handleSubmitCancel // fixes bug with empty comment and only an annotation.
        ,
        onClick: this.handleSubmitCancel // needed for keyboard accessibility (space and enter)

      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "comments.submit.cancel"
      }));

      var submitCancelButtonsContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: "submit-button-container"
      }, cancelButtonContainer, isOffline ? submitButtonWithTooltip : submitButtonWithoutTooltip);

      var submitIconContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: "submit-icon-container"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-testid": "ccx-comments-submit-button",
        icon: /*#__PURE__*/_react.default.createElement(_Send.default, {
          size: "M"
        }),
        variant: "tool",
        disabled: disableSavingChanges && !commentText.length,
        selected: !disableSavingChanges,
        onClick: disableSavingChanges ? undefined : this.handleCommentSubmit
      }));

      var textareaPlaceholder = 'comments.submit.placeholder';
      var placingInsertAnnotation = (isPlacingAnnotation || annotationLocationCoordinates && annotationLocationCoordinates.subtype === 'insert') && newAnnotationType === 'insert';
      var placingReplaceAnnotation = (isPlacingAnnotation || annotationLocationCoordinates && annotationLocationCoordinates.subtype === 'replace') && newAnnotationType === 'replace';

      if (placingInsertAnnotation) {
        textareaPlaceholder = 'comments.submit.placeholder_insert';
      } else if (placingReplaceAnnotation) {
        textareaPlaceholder = 'comments.submit.placeholder_replace';
      }

      var commentInput = /*#__PURE__*/_react.default.createElement(_CommentInput.default, {
        animationEnabled: !compactLayout,
        annotationsEnabled: annotationsEnabled && annotationsCreationEnabled,
        annotationTypes: annotationTypes,
        allowCollapseOverride: pendingStrikethroughAnnotation,
        className: "new-comment-textarea",
        compactLayout: compactLayout,
        initialValue: (0, _lodash.default)(dirtyComments, "".concat(assetData.nodeId, ".bodyValue"), ''),
        isAnnotating: isAnnotating,
        key: annotationsMultiPageEnabled ? 'single-submit-box' : assetData.nodeId,
        mentionsEnabled: !placingInsertAnnotation && !placingReplaceAnnotation && !isOffline && mentionsEnabled && !signedOut,
        onAnnotationClick: this.handleAnnotationClick,
        onFocus: this.handleOnFocus,
        onHeightChange: onHeightChange,
        onKeyUp: this.handleOnKeyUp,
        onMentionClick: this.handleMentionClick,
        onTextPresent: this.handleTextPresent,
        placeholder: textareaPlaceholder,
        ref: this.handleTextareaRef,
        richTextEntry: richTextEntry,
        touchControls: touchControls
      });

      var annotationToolbar;

      if (annotationsEnabled && annotationsCreationEnabled && annotationTypes) {
        annotationToolbar = /*#__PURE__*/_react.default.createElement(_AnnotationToolbar.default, {
          annotationColor: annotationColor,
          annotationTypes: annotationTypes,
          disabled: !isReadyToAnnotate,
          touchControls: touchControls,
          onAnnotationClick: this.handleAnnotationClick,
          isAnnotating: isAnnotating,
          newAnnotationType: newAnnotationType,
          saveAnnotationColor: saveAnnotationColor,
          compactLayout: compactLayout
        });
      }

      var desktopLayoutSubmitContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: "sign-in-buttons-container"
      }, annotationToolbar, commentInput, submitCancelButtonsContainer);

      var compactLayoutSubmitContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: "new-comment-form"
      }, annotationToolbar, /*#__PURE__*/_react.default.createElement("div", {
        className: "submit-textbox-container"
      }, commentInput, submitIconContainer));

      var hidecompactLayoutSubmitContainer = focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType !== 'root';

      if (compactLayout) {
        if (!hidecompactLayoutSubmitContainer) {
          return compactLayoutSubmitContainer;
        }

        return null;
      }

      return desktopLayoutSubmitContainer;
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
          imsData = _this$props13.imsData,
          viewingUnmapped = _this$props13.viewingUnmapped,
          spectrumUIScale = _this$props13.spectrumUIScale,
          theme = _this$props13.theme,
          reCaptchaEnabled = _this$props13.reCaptchaEnabled,
          reCaptchaSiteKey = _this$props13.reCaptchaSiteKey;
      var showLogin = this.state.showLogin;

      var contentBody = this._getContentBody(imsData);

      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-labelledby": "new-comment-heading",
        className: "".concat(_CommentsSubmitView.default.component, " ").concat(viewingUnmapped ? ' viewing-unmapped' : ''),
        id: _constants.SUBMIT_COMPONENT_ID,
        onClick: this.handleComponentClick
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "new-comment-heading",
        className: "visually-hidden"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "comments.sections.newComment"
      })), contentBody ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contentBody, /*#__PURE__*/_react.default.createElement(_Divider.default, null)) : null, /*#__PURE__*/_react.default.createElement(_Login.default, {
        beforeLogin: this.updateSessionStorageAnnotationLocation,
        onGuestLogin: this.handleGuestLogin,
        onLoginCancel: this.handleLoginCancel,
        show: showLogin,
        spectrumUIScale: spectrumUIScale,
        theme: theme,
        reCaptchaEnabled: reCaptchaEnabled,
        reCaptchaSiteKey: reCaptchaSiteKey
      }));
    }
  }]);

  return SubmitContainer;
}(_react.default.Component);

exports.PureSubmitContainer = SubmitContainer;

_defineProperty(SubmitContainer, "contextType", _CallbackContext.default);

SubmitContainer.defaultProps = {
  cacheComments: false,
  ccxIngest: {
    fireEvent: function fireEvent() {}
  },
  errors: {},
  isOffline: false,
  spectrumUIScale: 'medium',
  theme: 'light',
  reCaptchaSiteKey: ''
};
SubmitContainer.propTypes = {
  annotationColor: _propTypes.default.string,
  annotationLocationNodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  annotationLocationCoordinates: _propTypes.default.object,
  annotationsEnabled: _propTypes.default.bool.isRequired,
  annotationsCreationEnabled: _propTypes.default.bool.isRequired,
  annotationsMultiPageEnabled: _propTypes.default.bool.isRequired,
  annotationTypes: _propTypes.default.shape({
    draw: _propTypes.default.bool,
    pin: _propTypes.default.bool,
    text: _propTypes.default.bool
  }),
  assetData: _propTypes.default.shape({
    id: _propTypes.default.string,
    nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    ownerId: _propTypes.default.string,
    region: _propTypes.default.string
  }),
  cacheComments: _propTypes.default.bool,
  commentsPost: _propTypes.default.func,
  commentsAddDirtyComment: _propTypes.default.func,
  dirtyComments: _propTypes.default.object,
  currentView: _propTypes.default.oneOf(['resolved', 'unresolved']),
  ccxIngest: _propTypes.default.object.isRequired,
  hasAnnotationLocation: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  isPlacingAnnotation: _propTypes.default.bool,
  isReadyToAnnotate: _propTypes.default.bool,
  imageCapture: _propTypes.default.bool,
  imageContextData: _propTypes.default.object,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  mentionsEnabled: _propTypes.default.bool,
  annotatingItmId: _propTypes.default.string,
  saveAnnotationLocation: _propTypes.default.func,
  setAnnotationMode: _propTypes.default.func,
  compactLayout: _propTypes.default.bool,
  saveFocusedInputInfo: _propTypes.default.func,
  focusedInputInfo: _propTypes.default.object,
  commentsCloseBtnClicked: _propTypes.default.bool,
  onHeightChange: _propTypes.default.func,
  newAnnotationType: _propTypes.default.string,
  saveAnnotationColor: _propTypes.default.func,
  commentsListMinimized: _propTypes.default.bool,
  touchControls: _propTypes.default.bool,
  contextSetCommentsListMinimized: _propTypes.default.func,
  setUnmappedView: _propTypes.default.func.isRequired,
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest']),
  viewingUnmapped: _propTypes.default.bool,
  guestSessionState: _propTypes.default.string,
  resetGuestUserSession: _propTypes.default.func,
  reCaptchaEnabled: _propTypes.default.bool.isRequired,
  reCaptchaSiteKey: _propTypes.default.string,
  richTextEntry: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    annotationLocationCoordinates: (0, _annotations.getAnnotationLocationCoordinates)(state),
    guestSessionState: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.guestSessionState"))
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    resetGuestUserSession: ContextActions.contextResetGuestUserSession
  }, dispatch);
};

var enhance = (0, _redux.compose)(_AppContext.withAppContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
}), (0, _ccxIngest.ccxIngest)(_constants.INGEST_PROJECT_VALUE));

var _default = enhance(SubmitContainer);

exports.default = _default;